import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import React from 'react';
import { styles } from './FoldersListItemButton.styles';
import { FolderActionsMenuButton } from './FolderActionsMenuButton';

type FoldersListItemButtonProps = {
  text: string;
  selected?: boolean;
  small?: boolean;
  icon?: React.ReactNode;
  showActionsButton?: boolean;
  component?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'div' | 'p';
  onClick: () => void;
};

export function FoldersListItemButton({
  selected = false,
  small = false,
  icon = <FolderIcon />,
  showActionsButton = false,
  text,
  component = 'span',
  onClick
}: FoldersListItemButtonProps) {
  return (
    <ListItem
      sx={{ ...styles.container, ...(selected && styles.selected), ...(small && styles.small) }}
      data-test="foldersListItemButton"
      role="listitem"
      component="li"
      secondaryAction={showActionsButton && selected ? <FolderActionsMenuButton /> : null}
      onClick={() => {
        onClick();
      }}
    >
      <ListItemIcon sx={{ ...styles.icon, ...(selected && styles.selectedIcon) }}>{icon}</ListItemIcon>

      <ListItemText
        title={text}
        primary={text}
        primaryTypographyProps={{
          sx: { ...styles.text, ...(selected && styles.selectedText) },
          noWrap: true,
          variant: 'bodyDefault',
          component
        }}
      />
    </ListItem>
  );
}
